export class BrowserMouse {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
}
